<template>
  <b-card>
    <b-row>
      <b-col md="4">
        <b-input-group>
          <b-form-input
            v-model="filter"
            type="search"
            id="filterInput"
            placeholder="Type to Search"
            class="input-new"
          ></b-form-input>
          <b-input-group-append>
            <b-button :disabled="!filter" @click="filter = ''">x</b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>

    <!--TABLE -->
    <b-table
      show-empty
      head-variant="dark"
      striped
      hover
      bordered
      :items="items"
      :fields="fields"
      id="my-table"
      :per-page="perPage"
      :current-page="currentPage"
      :filter="filter"
      :filterIncludedFields="filterOn"
      @filtered="onFiltered"
    >
      <template v-slot:cell(role)="data">
        <span v-if="data.value == 1">Admin</span>
        <span v-if="data.value == 2">Stokis</span>
        <span v-if="data.value == 3">Home Dealer</span>
        <span v-if="data.value == 4">Agent</span>
        <span v-if="data.value == 5">Distributor</span>
      </template>
      <template v-slot:cell(action)="data">
        <span>
          <b-button
            variant="primary"
            size="sm"
            @click="onClickSubDealerView(data.item.id)"
            >{{ data.value.id }}VIEW</b-button
          >
        </span>
      </template>
    </b-table>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </b-card>
</template>

<script>
export default {
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      filter: null,
      filterOn: [],
      totalRows: 1
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    },
    rows() {
      return this.items.length;
    }
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
  },
  props: {
    fields: {
      type: Object,
      required: true
    },
    items: {
      type: Object,
      required: true
    }
  },

  methods: {
    // onClickView() {
    //   this.$router.push({ path: `stockout_view_user` });
    // },
    onClickSubDealerView(id) {
      this.$router.push({
        path: `subdealer_next?id=${id}&cat=1`
      });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }
  }
};
</script>
<style lang="css" scoped></style>
